export default {
  "wx.mobi321.com": {
    ad1: [
      {
        type: "dex",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175008821450467369",
        p1: "diddg",
        p2: "jfhk",
        position: "position-08",
      },
    ],
    floorAd: [
      {
        type: "floorAd",
        ownerId: 11635561,
        containerId: "adfox_175008831508897369",
        platform: "touch",
        p1: "diddf",
        p2: "jkqc",
        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "dex",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175008824923327369",
        p1: "diddh",
        p2: "jfhl",
        position: "position-09",
      },
      {
        type: "dex",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175008838892537369",
        p1: "diddi",
        p2: "jfhl",
        position: "position-13",
      },
      {
        type: "dex",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175008826912377369",
        p1: "diddj",
        p2: "jfhl",
        position: "position-14",
      },
      {
        type: "dex",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175008828898337369",
        p1: "diddk",
        p2: "jfhl",
        position: "position-15",
      },
    ],
  },
};
